import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useCampaignsStore = defineStore('campaigns', {
  state,
  getters,
  actions
})

export default useCampaignsStore
